import { Link } from 'react-router-dom';

function ExerciseLayout({ name, image, description, actionButton, actionLink }) {
  return (
    <article className="card overflow-hidden p-0">
      <div className="p-6 sm:p-8">
        <h2 className="text-xl font-bold text-white mb-4">{name}</h2>
        <div className="flex flex-col md:flex-row gap-6">
          <div className="flex flex-col flex-shrink-0 w-full md:w-72 gap-1.5">
            <div className="h-44 md:h-52 flex items-start justify-center overflow-hidden rounded-lg">
              <img
                src={image}
                alt={name}
                className="max-w-full max-h-full w-auto h-auto object-contain"
              />
            </div>
            {actionButton && actionLink && (
              <Link
                to={actionLink}
                className="inline-flex items-center justify-center gap-1.5 rounded-lg bg-blue-600 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50"
              >
                {actionButton}
                <span aria-hidden>→</span>
              </Link>
            )}
          </div>
          <div className="flex-1 text-neutral-300 text-sm leading-relaxed min-w-0">
            {description.split('\n').map((line, index) => (
              <p key={index} className={index > 0 ? 'mt-2' : ''}>
                {line}
              </p>
            ))}
          </div>
        </div>
      </div>
    </article>
  );
}

export default ExerciseLayout;